export default "__VITE_ASSET__jgWXoQH8__"